export enum TimelineItemType {
    Consultation = 1,
    Antecedent = 2,
    Sphere = 3,
    Attachment = 4,
    Pediatrics = 5,
}
